import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function FDWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1154">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1155">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1156">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1157">
            WHAT ARE FAT DISSOLVING INJECTIONS?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1158"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-1159">
            Fat dissolving injections, also known as lipolytic injections or
            lipotropic injections, are non-surgical treatments designed to
            reduce localized fat deposits in specific areas of the body.
          </p>

          {/* Pull Quote */}
          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1160">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1161">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1162">
              It's like one day you wake up, look in the mirror, and think,
              'Where did that come from?' And no matter how many salads you eat
              or how hard you hit the gym, it just doesn't budge. This can be a
              confidence-killer for men and women alike.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1163">
            <p data-id="element-1164">
              These injections typically contain compounds like
              phosphatidylcholine (PC) and deoxycholate (DC), which help break
              down fat cells by disrupting their membranes. The dissolved fat is
              then metabolized and eliminated from the body through natural
              processes.
            </p>
            <p data-id="element-1165">
              Fat dissolving injections are commonly used to target areas like
              the abdomen, thighs, buttocks, chin, and arms. Multiple treatment
              sessions may be required to achieve desired results, and the
              effectiveness of the treatment can vary depending on individual
              factors like the amount of fat and skin laxity in the treated
              area.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}